(function(){
  if(window.__rcAnim) return; window.__rcAnim = true;
  var me = document.currentScript || document.querySelector('script[src*="rc-anim.js"]');
  if(me && !document.getElementById('rc-fx-css')){ var l=document.createElement('link'); l.id='rc-fx-css'; l.rel='stylesheet'; l.href=me.src.replace('rc-anim.js','rc-fx.css'); document.head.appendChild(l); }
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(reduce || !('IntersectionObserver' in window)) { document.documentElement.classList.remove('rc-js'); return; }
  document.documentElement.classList.add('rc-js');
  var fine = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var SEL = '.rc-head,.rc-card,.rc-ccard,.rc-show__card,.rc-panel,.rc-trust__item,.rc-stat,.rc-review,.rc-badge-card,.rc-faq .rc-acc,.rc-news,.rc-val,.rc-contact__card,.rc-cform,.rc-mis>*,.rc-bs,.rc-toolbar,.rc-chead__count,.rc-crumbs2,.rc-chead .rte,.rc-tm__top,.rc-hs__head,.rc-circle,.rc-dl__row';

  function count(el){
    var t = el.textContent, m = t.match(/[0-9][0-9,.]*/); if(!m) return;
    var raw = m[0], num = parseFloat(raw.replace(/,/g,'')); if(isNaN(num)) return;
    var dec = (raw.split('.')[1] || '').length, pre = t.slice(0, m.index), suf = t.slice(m.index + raw.length), start = null, dur = 1500;
    function fmt(n){ var s = n.toFixed(dec); if(raw.indexOf(',') > -1){ var p = s.split('.'); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ','); s = p.join('.'); } return pre + s + suf; }
    function step(ts){ if(!start) start = ts; var k = Math.min((ts - start) / dur, 1), e = 1 - Math.pow(1 - k, 3); el.textContent = fmt(num * e); if(k < 1) requestAnimationFrame(step); else el.textContent = t; }
    requestAnimationFrame(step);
  }
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(!e.isIntersecting) return;
      e.target.classList.add('is-in'); io.unobserve(e.target);
      if(e.target.classList.contains('rc-stat')){ var b = e.target.querySelector('b'); if(b) count(b); }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
  function reveal(){
    document.querySelectorAll(SEL).forEach(function(el){
      if(el.classList.contains('rc-reveal') || el.closest('.rc-hs__track,.rc-tm__row,.rc-usm')) return;
      var i = el.parentElement ? Array.prototype.indexOf.call(el.parentElement.children, el) : 0;
      el.style.setProperty('--rc-d', (Math.min(i % 12, 8) * 0.07) + 's');
      el.classList.add('rc-reveal'); io.observe(el);
    });
  }

  var uiDone = false;
  function ui(){
    if(uiDone || !document.body) return; uiDone = true;
    var bar = document.createElement('div'); bar.className = 'rc-progress'; document.body.appendChild(bar);
    var b = document.createElement('button'); b.type = 'button'; b.className = 'rc-totop'; b.setAttribute('aria-label','Back to top');
    b.innerHTML = '<svg viewBox="0 0 52 52" aria-hidden="true"><circle class="rc-ring-bg" cx="26" cy="26" r="24"/><circle class="rc-ring" cx="26" cy="26" r="24" stroke-dasharray="150.8" stroke-dashoffset="150.8"/></svg><span aria-hidden="true">&uarr;</span>';
    document.body.appendChild(b);
    var ring = b.querySelector('.rc-ring');
    b.addEventListener('click', function(){ if(window.rcLenis){ window.rcLenis.scrollTo(0); } else { window.scrollTo({ top: 0, behavior: 'smooth' }); } });
    var heroInner = document.querySelector('.rc-hero__inner');
    var tick = false;
    function upd(){
      tick = false;
      var h = document.documentElement.scrollHeight - window.innerHeight;
      var p = h > 0 ? Math.min(window.scrollY / h, 1) : 0;
      bar.style.transform = 'scaleX(' + p.toFixed(4) + ')';
      ring.style.strokeDashoffset = (150.8 * (1 - p)).toFixed(1);
      b.classList.toggle('is-on', window.scrollY > 600);
      if(fine && heroInner && window.scrollY < window.innerHeight){
        heroInner.style.translate = '0 ' + (window.scrollY * 0.25).toFixed(1) + 'px';
        heroInner.style.opacity = Math.max(0, 1 - window.scrollY / 650).toFixed(3);
      }
    }
    window.addEventListener('scroll', function(){ if(!tick){ tick = true; requestAnimationFrame(upd); } }, { passive: true });
    upd();
  }

  var wio = new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('is-words-in'); wio.unobserve(e.target); } }); }, { threshold: 0.3 });
  function words(){
    document.querySelectorAll('.rc-h2,.rc-ph h1,.rc-mis__statement,.rc-chead h1,.rc-hs__title,.rc-usm__title').forEach(function(h){
      if(h.getAttribute('data-rc-words')) return; h.setAttribute('data-rc-words','1');
      var i = 0;
      function wrapNode(){ var w = document.createElement('span'); w.className = 'rc-w'; var s = document.createElement('span'); s.style.setProperty('--i', i++); w.appendChild(s); return { w: w, s: s }; }
      (function walk(node){
        Array.prototype.slice.call(node.childNodes).forEach(function(n){
          if(n.nodeType === 3){
            var parts = n.textContent.split(/(\s+)/), frag = document.createDocumentFragment();
            parts.forEach(function(p){ if(!p) return; if(/^\s+$/.test(p)){ frag.appendChild(document.createTextNode(p)); return; } var x = wrapNode(); x.s.textContent = p; frag.appendChild(x.w); });
            n.parentNode.replaceChild(frag, n);
          } else if(n.nodeType === 1){
            if(n.tagName === 'EM'){ var x = wrapNode(); n.parentNode.insertBefore(x.w, n); x.s.appendChild(n); }
            else walk(n);
          }
        });
      })(h);
      wio.observe(h);
    });
  }

  function tilt(){
    if(!fine) return;
    document.querySelectorAll('.rc-show__card,.rc-ccard,.rc-val,.rc-badge-card,.rc-tm__card,.rc-hs__card').forEach(function(c){
      if(c.getAttribute('data-rc-tilt')) return; c.setAttribute('data-rc-tilt','1');
      var g = document.createElement('span'); g.className = 'rc-glare'; c.appendChild(g);
      var max = c.classList.contains('rc-show__card') || c.classList.contains('rc-hs__card') ? 7 : 4, raf = null;
      c.addEventListener('mousemove', function(e){
        var r = c.getBoundingClientRect(), x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
        if(raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function(){
          c.classList.add('rc-tilting');
          c.style.transition = 'transform .12s ease-out, box-shadow .3s';
          c.style.transform = 'perspective(900px) rotateX(' + ((0.5 - y) * max).toFixed(2) + 'deg) rotateY(' + ((x - 0.5) * max).toFixed(2) + 'deg) translateY(-6px)';
          c.style.setProperty('--mx', (x * 100).toFixed(1) + '%'); c.style.setProperty('--my', (y * 100).toFixed(1) + '%');
        });
      });
      c.addEventListener('mouseleave', function(){ if(raf) cancelAnimationFrame(raf); c.classList.remove('rc-tilting'); c.style.transition = 'transform .7s cubic-bezier(.2,.7,.2,1), box-shadow .3s'; c.style.transform = ''; });
    });
  }

  function magnet(){
    if(!fine) return;
    document.querySelectorAll('.rc-btn,.rc-show__cta,.rc-bs__arrow,.rc-tm__pause').forEach(function(b){
      if(b.getAttribute('data-rc-mag')) return; b.setAttribute('data-rc-mag','1');
      b.addEventListener('mousemove', function(e){ var r = b.getBoundingClientRect(); var x = e.clientX - r.left - r.width / 2, y = e.clientY - r.top - r.height / 2; b.style.translate = (x * 0.18).toFixed(1) + 'px ' + (y * 0.3).toFixed(1) + 'px'; });
      b.addEventListener('mouseleave', function(){ b.style.translate = ''; });
    });
  }

  function spot(){
    if(!fine) return;
    document.querySelectorAll('.rc-panel,.rc-news,.rc-stats,.rc-bs__slide,.rc-hero,.rc-ph,.rc-usm__pin,.rc-tm').forEach(function(el){
      if(el.getAttribute('data-rc-spot')) return; el.setAttribute('data-rc-spot','1');
      var s = document.createElement('span'); s.className = 'rc-spot'; s.setAttribute('aria-hidden','true'); el.insertBefore(s, el.firstChild);
      el.addEventListener('mousemove', function(e){ var r = el.getBoundingClientRect(); el.style.setProperty('--mx', (e.clientX - r.left) + 'px'); el.style.setProperty('--my', (e.clientY - r.top) + 'px'); el.classList.add('rc-spot-on'); });
      el.addEventListener('mouseleave', function(){ el.classList.remove('rc-spot-on'); });
    });
  }

  function parallax(){
    if(!fine) return;
    document.querySelectorAll('.rc-hero,.rc-bs__slide').forEach(function(h){
      if(h.getAttribute('data-rc-par')) return; h.setAttribute('data-rc-par','1');
      var wrap = h.querySelector('.rc-hero__products,.rc-bs__art');
      var plates = h.querySelectorAll('.rc-hero__plate,.rc-bs__plate');
      if(!wrap && !plates.length) return;
      h.addEventListener('mousemove', function(e){
        var r = h.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
        if(wrap) wrap.style.translate = (x * -24).toFixed(1) + 'px ' + (y * -18).toFixed(1) + 'px';
        plates.forEach(function(pl, i){ pl.style.translate = (x * (i + 1) * 14).toFixed(1) + 'px ' + (y * (i + 1) * 12).toFixed(1) + 'px'; });
      });
      h.addEventListener('mouseleave', function(){ if(wrap) wrap.style.translate = ''; plates.forEach(function(pl){ pl.style.translate = ''; }); });
    });
  }

  function dust(){
    document.querySelectorAll('.rc-hero--art,.rc-ph').forEach(function(host){
      if(host.getAttribute('data-rc-dust')) return; host.setAttribute('data-rc-dust','1');
      var c = document.createElement('canvas'); c.className = 'rc-fx-canvas'; c.setAttribute('aria-hidden','true'); host.insertBefore(c, host.firstChild);
      var ctx = c.getContext && c.getContext('2d'); if(!ctx) return;
      var w, h, dpr = Math.min(window.devicePixelRatio || 1, 2), ps = [], run = false, raf;
      function size(){ w = host.clientWidth; h = host.clientHeight; c.width = w * dpr; c.height = h * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0); }
      function make(){ ps = []; var n = Math.round(Math.min(fine ? 60 : 28, w / 22)); for(var i = 0; i < n; i++){ ps.push({ x: Math.random() * w, y: Math.random() * h, r: Math.random() * 1.8 + 0.4, s: Math.random() * 0.35 + 0.1, d: Math.random() * 6.283, a: Math.random() * 0.6 + 0.2 }); } }
      function draw(){
        ctx.clearRect(0, 0, w, h);
        for(var i = 0; i < ps.length; i++){ var p = ps[i]; p.y -= p.s; p.d += 0.01; p.x += Math.sin(p.d) * 0.3; if(p.y < -5){ p.y = h + 5; p.x = Math.random() * w; } ctx.beginPath(); ctx.arc(p.x, p.y, p.r, 0, 6.283); ctx.fillStyle = 'rgba(96,220,189,' + (p.a * (0.6 + 0.4 * Math.sin(p.d * 3))).toFixed(3) + ')'; ctx.fill(); }
        if(run) raf = requestAnimationFrame(draw);
      }
      size(); make();
      new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting && !run){ run = true; draw(); } else if(!e.isIntersecting){ run = false; cancelAnimationFrame(raf); } }); }).observe(host);
      var rt; window.addEventListener('resize', function(){ clearTimeout(rt); rt = setTimeout(function(){ size(); make(); }, 200); });
    });
  }

  function zoom(){
    if(!fine) return;
    document.querySelectorAll('.rc-gallery__main').forEach(function(m){
      if(m.getAttribute('data-rc-zoom')) return; m.setAttribute('data-rc-zoom','1');
      m.addEventListener('mousemove', function(e){ var img = m.querySelector('img'); if(!img) return; var r = m.getBoundingClientRect(); img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100).toFixed(1) + '% ' + ((e.clientY - r.top) / r.height * 100).toFixed(1) + '%'; img.style.transform = 'scale(1.9)'; });
      m.addEventListener('mouseleave', function(){ var img = m.querySelector('img'); if(img) img.style.transform = ''; });
    });
  }

  function init(){ reveal(); ui(); words(); tilt(); magnet(); spot(); parallax(); dust(); zoom(); }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
